// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__5x2cA","tile":"loader_tile__U-5Td","jump":"loader_jump__vZUEd","spin":"loader_spin__1-Dpg","shadow":"loader_shadow__Wks1Y"};